import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import CreateCustomer from "./CreatemarketCustomer";
import EditmarketCustomer from "./EditmarketCustomer";
import ViewmarketCustomer from "./ViewmarketCustomer";
import CustomerList from "./Marketleadlist";
import TargetList from "./TargetList";


export default function Marketleadtracker() {
  return (
    <Switch>
      <Redirect exact={true} from="/market-target-lead" to="/market-target-lead/customer-list" />

      {/* Layout */}
      <Route exact={true} path="/market-target-lead/customer-list" component={CustomerList} />
      <Route exact={true} path="/market-target-lead/customer-particular-list" component={TargetList} />
      <Route exact={true} path="/market-target-lead/customer-create" component={CreateCustomer} />
      <Route exact={true} path="/market-target-lead/customer-edit" component={EditmarketCustomer} />
      <Route exact={true} path="/market-target-lead/customer-view" component={ViewmarketCustomer} />
     
    </Switch>
  );
}
